const productData = [
  {
    id: 101,
    name: "Combined coat with detachable collar",
    category: "Coats",
    price: "199.00",
    country: "Mangoes Kids",
    rating: 4.8,
    reviewCount: 132,
    images: [
      "/img/101.avif",
      "/img/101a.avif",
      "/img/101b.avif",
      "/img/101c.avif",
      "/img/101d.avif",
    ],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm"],
    description: [
      "Soft wool-blend exterior with tonal faux-fur collar that buttons off for warmer days.",
      "Quilted satin lining and light padding provide cozy insulation without bulk.",
      "Hidden zip and snap placket maintain a polished finish while keeping wind out.",
    ],
    Features: [
      "Type: combined coat with detachable collar",
      "Closure: concealed zipper with snap buttons",
      "Care: dry clean only",
    ],
  },
  {
    id: 102,
    name: "Manteco wool coat with fur collar",
    category: "Coats",
    price: "159.00",
    country: "Mangoes Kids",
    rating: 4.6,
    reviewCount: 84,
    images: [
      "/img/102.avif",
      "/img/102a.avif",
      "/img/102b.avif",
      "/img/102c.avif",
    ],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm", "160cm"],
    description: [
      "Premium Manteco® recycled wool cloth with a brushed handfeel.",
      "Detachable faux-fur shawl collar adds warmth and playful volume.",
      "Straight silhouette with front darts designed for layering over knits.",
    ],
    Features: [
      "Type: wool coat with removable collar",
      "Fabric: Manteco recycled wool blend",
      "Care: professional dry clean",
    ],
  },
  {
    id: 103,
    name: "Lapels bouclé coat",
    category: "Coats",
    price: "129.00",
    country: "Mangoes Kids",
    rating: 4.5,
    reviewCount: 91,
    images: [
      "/img/103.webp",
      "/img/103a.avif",
      "/img/103b.avif",
      "/img/103c.avif",
      "/img/103d.avif",
      "/img/103e.avif",
      "/img/103f.avif",
    ],
    size: ["100cm", "110cm", "120cm", "130cm", "140cm"],
    description: [
      "Bouclé knit surface with tonal lapel collar inspired by classic pea coats.",
      "Button-through front with interior grosgrain tape for durability.",
      "Side welt pockets lined in microfleece keep little hands warm.",
    ],
    Features: [
      "Type: bouclé coat with lapels",
      "Pockets: two front welt pockets",
      "Care: machine wash cold, line dry",
    ],
  },
  {
    id: 104,
    name: "Manteco wool coat with belt",
    category: "Coats",
    price: "219.00",
    country: "Mangoes Kids",
    rating: 4.7,
    reviewCount: 65,
    images: [
      "/img/104.avif",
      "/img/104a.webp",
      "/img/104b.webp",
      "/img/104c.webp",
      "/img/104d.webp",
    ],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm", "160cm"],
    description: [
      "Longline wrap silhouette crafted in Manteco® double-faced wool.",
      "Self-fabric belt cinches the waist and can be removed for open wear.",
      "Interior seams are hand-finished for a clean, unlined construction.",
    ],
    Features: [
      "Type: belted wool coat",
      "Fabric: double-faced Manteco wool blend",
      "Care: dry clean recommended",
    ],
  },
  {
    id: 105,
    name: "Double-breasted wool coat",
    category: "Coats",
    price: "229.00",
    country: "Mangoes Kids",
    rating: 4.9,
    reviewCount: 118,
    images: [
      "/img/105.avif",
      "/img/105a.webp",
      "/img/105b.avif",
      "/img/105c.avif",
      "/img/105d.avif",
    ],
    size: ["100cm", "110cm", "120cm", "130cm", "140cm", "150cm"],
    description: [
      "Heritage-inspired double-breasted front with matte horn-effect buttons.",
      "Structured shoulders and tailored seams keep the coat tidy through play.",
      "Half-lined interior with contrast piping and name label for school days.",
    ],
    Features: [
      "Type: double-breasted coat",
      "Lining: partial polyester lining",
      "Care: dry clean only",
    ],
  },
  {
    id: 106,
    name: "Wool-blend micro-houndstooth coat",
    category: "Coats",
    price: "189.00",
    country: "Mangoes Kids",
    rating: 4.4,
    reviewCount: 77,
    images: ["/img/106.avif"],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm"],
    description: [
      "Micro-houndstooth pattern woven into a soft wool-blend cloth.",
      "Point collar and button placket mirror classic menswear tailoring.",
      "Interior hanger loop and smooth lining make on-and-off effortless.",
    ],
    Features: [
      "Type: patterned wool-blend coat",
      "Pattern: micro-houndstooth check",
      "Care: dry clean preferred",
    ],
  },
  {
    id: 107,
    name: "Handmade wool coat with belt",
    category: "Coats",
    price: "188.00",
    country: "Mangoes Kids",
    rating: 4.9,
    reviewCount: 54,
    images: [
      "/img/107.avif",
      "/img/107a.avif",
      "/img/107b.avif",
      "/img/107c.avif",
      "/img/107d.avif",
      "/img/107e.avif",
    ],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm", "160cm"],
    description: [
      "Hand-finished seams deliver a lightweight drape with premium feel.",
      "Removable belt and hidden snap closure let kids customize the fit.",
      "Large patch pockets and back vent allow easy movement during play.",
    ],
    Features: [
      "Type: handmade belted coat",
      "Construction: hand-sewn interior seams",
      "Care: dry clean only",
    ],
  },
  {
    id: 108,
    name: "Satin dress with gathered V-neckline",
    category: "Dresses",
    price: "69.99",
    country: "Mangoes Kids",
    rating: 4.7,
    reviewCount: 103,
    images: [
      "/img/108.mp4",
      "/img/108a.avif",
      "/img/108b.avif",
      "/img/108c.avif",
      "/img/108d.avif",
      "/img/108e.avif",
      "/img/108f.avif",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Smooth satin fabric with a subtle luster in a rich rust hue.",
      "Deep V-neckline with delicate front ring gather detail.",
      "Sleeveless design with fine spaghetti straps.",
      "Flattering bias cut for a fluid, body-skimming drape.",
    ],
    Features: [
      "Type: satin slip dress",
      "Neckline: gathered V-neck with ring",
      "Straps: adjustable spaghetti straps",
      "Care: hand wash cold, dry flat",
    ],
  },
  {
    id: 109,
    name: "A-line linen dress",
    category: "Dresses",
    price: "79.99",
    country: "Mangoes Kids",
    rating: 4.8,
    reviewCount: 147,
    images: ["/img/109.avif", "/img/109a.avif", "/img/109b.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Crisp and breathable white linen fabric perfect for warm days.",
      "Classic A-line silhouette that flatters and provides ease of movement.",
      "Square neckline and wide shoulder straps for a structured look.",
      "Midi length with a clean, minimalist design.",
    ],
    Features: [
      "Type: A-line dress",
      "Fabric: breathable linen blend",
      "Neckline: square neck",
      "Care: machine wash cold, line dry",
    ],
  },
  {
    id: 1010,
    name: "Halter polka dot dress",
    category: "Dresses",
    price: "49.99",
    country: "Mangoes Kids",
    rating: 4.3,
    reviewCount: 96,
    images: [
      "/img/1010.avif",
      "/img/1010a.avif",
      "/img/1010b.avif",
      "/img/1010c.avif",
      "/img/1010d.avif",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Lightweight chiffon fabric featuring a playful micro polka dot print.",
      "High halter neckline with an elegant back tie closure.",
      "Smocked elastic waist for a comfortable, defining fit.",
      "Tiered, ruffled mini skirt adds flirty volume and movement.",
    ],
    Features: [
      "Type: halter mini dress",
      "Pattern: micro polka dot",
      "Waist: elastic smocking",
      "Care: hand wash cold, hang to dry",
    ],
  },
  {
    id: 1011,
    name: "Draped halter dress",
    category: "Dresses",
    price: "49.99",
    country: "Mangoes Kids",
    rating: 4.6,
    reviewCount: 112,
    images: [
      "/img/1011.avif",
      "/img/1011a.avif",
      "/img/1011b.avif",
      "/img/1011c.avif",
      "/img/1011d.avif",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Vibrant cobalt blue fabric with a textured, slightly crinkled finish.",
      "Chic halter neckline that highlights the shoulders.",
      "Sophisticated draped detailing across the bodice and waist.",
      "Fitted silhouette that accentuates the figure beautifully.",
    ],
    Features: [
      "Type: draped midi dress",
      "Neckline: halter neck",
      "Details: front draping and ruching",
      "Care: machine wash delicate, do not tumble dry",
    ],
  },
  {
    id: 1012,
    name: "Floral-print halter dress",
    category: "Dresses",
    price: "49.99",
    country: "Mangoes Kids",
    rating: 4.5,
    reviewCount: 108,
    images: [
      "/img/1012.avif",
      "/img/1012a.avif",
      "/img/1012b.avif",
      "/img/1012c.avif",
      "/img/1012d.avif",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Soft, lightweight fabric adorned with a bold purple and green floral print.",
      "Classic square neckline paired with wide, supportive straps.",
      "Fitted bodice leading into a gently flared midi-length skirt.",
      "Perfect for garden parties or vibrant summer outings.",
    ],
    Features: [
      "Type: floral midi dress",
      "Pattern: large floral print",
      "Neckline: square neck with wide straps",
      "Care: machine wash cold, iron low",
    ],
  },
  {
    id: 1013,
    name: "Polka dot balloon jeans",
    category: "Bottoms",
    price: "49.99",
    country: "Mangoes Kids",
    rating: 4.4,
    reviewCount: 87,
    images: [
      "/img/1013.avif",
      "/img/1013a.avif",
      "/img/1013b.avif",
      "/img/1013c.avif",
      "/img/1013d.avif",
      "/img/1013e.avif",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Sturdy cotton denim in a dark brown wash with an all-over white polka dot pattern.",
      "Trendy balloon leg silhouette offering a relaxed and roomy fit.",
      "High-rise waist with classic five-pocket styling and zip fly.",
      "Tapered slightly at the ankle for a distinctive, modern shape.",
    ],
    Features: [
      "Type: balloon fit jeans",
      "Pattern: polka dot print",
      "Pockets: classic 5-pocket design",
      "Care: machine wash cold inside out",
    ],
  },
  {
    id: 1014,
    name: "Midi-dress with waist tie",
    category: "Dresses",
    price: "199.00",
    country: "Mangoes Kids",
    rating: 4.7,
    reviewCount: 74,
    images: [
      "/img/1014.avif",
      "/img/1014a.avif",
      "/img/1014b.avif",
      "/img/1014c.avif",
      "/img/1014d.avif",
    ],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm"],
    description: [
      "Flowy midi length in soft viscose with subtle twill texture.",
      "Removable waist tie allows a bow detail or relaxed fit.",
      "Button front and elastic cuffs make dressing quick for busy mornings.",
    ],
    Features: [
      "Type: midi dress with belt",
      "Details: adjustable waist tie, button placket",
      "Care: machine wash cold",
    ],
  },
  {
    id: 1015,
    name: "Halter long jumpsuit",
    category: "Jumpsuits",
    price: "109.00",
    country: "Mangoes Kids",
    rating: 4.5,
    reviewCount: 66,
    images: [
      "/img/1015.avif",
      "/img/1015a.avif",
      "/img/1015b.avif",
      "/img/1015c.avif",
      "/img/1015d.avif",
    ],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm"],
    description: [
      "Fluid jumpsuit with halter neckline and elastic back for comfort.",
      "Wide-leg silhouette gives room to move for parties or playdates.",
      "Side pockets and concealed zip keep the profile neat.",
    ],
    Features: [
      "Type: long halter jumpsuit",
      "Neckline: adjustable halter tie",
      "Care: machine wash delicate cycle",
    ],
  },
  {
    id: 1016,
    name: "Long dress with side slit",
    category: "Dresses",
    price: "79.00",
    country: "Mangoes Kids",
    rating: 4.6,
    reviewCount: 58,
    images: [
      "/img/1016.avif",
      "/img/1016a.avif",
      "/img/1016b.avif",
      "/img/1016c.avif",
      "/img/1016d.avif",
      "/img/1016e.avif",
    ],
    size: ["120cm", "130cm", "140cm", "150cm", "160cm"],
    description: [
      "Maxi-length dress crafted in soft ribbed knit with gentle stretch.",
      "Side slit offers ease of movement while staying on-trend.",
      "Crew neckline and long sleeves make it a versatile layering base.",
    ],
    Features: [
      "Type: long rib dress",
      "Detail: side slit at hem",
      "Care: machine wash cold inside out",
    ],
  },
  {
    id: 1017,
    name: "Strapless maxi-dress",
    category: "Dresses",
    price: "89.00",
    country: "Mangoes Kids",
    rating: 4.4,
    reviewCount: 63,
    images: [
      "/img/1017.avif",
      "/img/1017a.avif",
      "/img/1017b.avif",
      "/img/1017c.avif",
      "/img/1017d.avif",
      "/img/1017e.avif",
      "/img/1017f.avif",
    ],
    size: ["120cm", "130cm", "140cm", "150cm"],
    description: [
      "Smocked bodice delivers a secure strapless fit ideal for summer events.",
      "Tiered skirt adds volume with lightweight cotton voile layers.",
      "Includes optional removable straps for playground-ready support.",
    ],
    Features: [
      "Type: strapless tiered maxi dress",
      "Bodice: elastic smocking",
      "Care: machine wash gentle, hang dry",
    ],
  },
  {
    id: 1018,
    name: "Lurex jacket with buttons",
    category: "Coats",
    price: "129.00",
    country: "Mangoes Kids",
    rating: 4.7,
    reviewCount: 71,
    images: [
      "/img/1018.avif",
      "/img/1018a.avif",
      "/img/1018b.avif",
      "/img/1018c.avif",
      "/img/1018d.avif",
    ],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm"],
    description: [
      "Sparkling lurex threads woven into a tweed-effect knit for party looks.",
      "Gold-tone crest buttons and fringe trims elevate the jacket.",
      "Soft jersey lining keeps the style comfy against the skin.",
    ],
    Features: [
      "Type: lurex tweed jacket",
      "Fastening: gold-tone buttons",
      "Care: hand wash cold",
    ],
  },
  {
    id: 1019,
    name: "Printed cotton jacket",
    category: "Coats",
    price: "169.00",
    country: "Mangoes Kids",
    rating: 4.3,
    reviewCount: 88,
    images: ["/img/1019.avif", "/img/1019a.webp", "/img/1019b.webp"],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm"],
    description: [
      "All-over floral print on breathable cotton poplin.",
      "Button placket and collar nod to classic overshirt styling.",
      "Unlined construction perfect for transitional weather layering.",
    ],
    Features: [
      "Type: printed cotton overshirt",
      "Pattern: all-over floral",
      "Care: machine wash cold, tumble dry low",
    ],
  },
  {
    id: 1020,
    name: "Faux-fur coat with buttons",
    category: "Coats",
    price: "149.00",
    country: "Mangoes Kids",
    rating: 4.8,
    reviewCount: 115,
    images: [
      "/img/1020.avif",
      "/img/1020a.avif",
      "/img/1020b.avif",
      "/img/1020c.webp",
      "/img/1020d.avif",
    ],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm", "160cm"],
    description: [
      "Ultra-plush faux fur with silky lining keeps little ones snug in winter.",
      "Front button closure sized for small hands to fasten easily.",
      "Rounded collar and slightly oversized fit create a playful finish.",
    ],
    Features: [
      "Type: faux-fur coat",
      "Closure: front buttons",
      "Care: professional dry clean",
    ],
  },
  {
    id: 1021,
    name: "Crossed halter crop top",
    category: "Tops",
    price: "35.99",
    country: "Mangoes Kids",
    rating: 4.5,
    reviewCount: 115,
    images: [
      "/img/1021.avif",
      "/img/1021a.avif",
      "/img/1021b.avif",
      "/img/1021c.avif",
      "/img/1021d.avif",
    ],
    size: ["S", "M", "L"],
    description: [
      "Cotton and lyocell blend fabric.",
      "Fitted design with a cropped length.",
      "Halter neck with crossed detail at the front.",
      "Invisible side zip fastening. Total look.",
      "Designed to elevate your looks for special occasions.",
    ],
    Features: [
      "Composition: 46% lyocell, 29% linen, 25% cotton",
      "Origin: Designed in Barcelona, Manufacture in Morocco",
      "Care: Hand washing max 30°C / 85°F",
      "Care: Do not bleach",
      "Care: Ironing max 110°C / 230°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1022,
    name: "Poplin shirt with pocket",
    category: "Tops",
    price: "34.99",
    country: "Mangoes Kids",
    rating: 4.6,
    reviewCount: 203,
    images: ["/img/1022.png", "/img/1022a.png", "/img/1022b.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Classic poplin shirt with a single chest pocket.",
      "Regular fit with a comfortable, easy-to-wear silhouette.",
      "Point collar and button-front closure.",
      "Perfect for both casual and semi-formal occasions.",
    ],
    Features: [
      "Type: poplin shirt with pocket",
      "Composition: 82% cotton, 15% polyamide, 3% elastane",
      "Origin: Designed in Barcelona, Manufacture in Morocco",
      "Origin: Dye/printing: Turkiye",
      "Origin: Weave: Turkiye",
      "Care: Machine washing max 30°C / 85°F",
      "Care: Do not bleach",
      "Care: Ironing max 150°C / 300°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1023,
    name: "Metallic funnel-heel sandal",
    category: "Shoes",
    price: "69.99",
    country: "Mangoes Kids",
    rating: 4.7,
    reviewCount: 312,
    images: ["/img/1023.avif", "/img/1023a.avif", "/img/1023b.avif", "/img/1023c.avif"],
    size: ["35", "36", "37", "38", "39", "40", "41"],
    description: [
      "Elegant metallic finish with a distinctive funnel heel design.",
      "Open-toe silhouette perfect for warm weather.",
      "Comfortable insole for all-day wear.",
      "Versatile style suitable for both casual and dressy occasions.",
    ],
    Features: [
      "Type: metallic funnel-heel sandal",
      "Shoeupper: 59% polyurethane, 41% polyester",
      "Insole: 59% polyurethane, 41% polyester",
      "Sole: 100% rubber",
      "Fixing sole: 100% glued",
      "(shoes) lining: 60% polyurethane, 40% polyester",
      "Origin: Designed in Barcelona, Manufacture: Spain",
      "Care: No washing",
      "Care: Do not bleach",
      "Care: Do not iron",
      "Care: Do not dry clean",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1024,
    name: "Check mini shorts",
    category: "Bottoms",
    price: "29.99",
    country: "Mangoes Kids",
    rating: 4.5,
    reviewCount: 187,
    images: ["/img/1024.avif", "/img/1024a.avif", "/img/1024b.avif", "/img/1024c.webp", "/img/1024d.avif"],
    size: ["35", "36", "37", "38", "39", "40", "41"],
    description: [
      "Classic check pattern in a versatile mini length.",
      "Regular fit with a comfortable waistband.",
      "Perfect for casual summer outings.",
      "Easy to pair with tops for a complete look.",
    ],
    Features: [
      "Type: check mini shorts",
      "Composition: 100% cotton",
      "Origin: Designed in Barcelona, Manufacture: Morocco",
      "Origin: Dye/printing: Spain",
      "Origin: Weave: Spain",
      "Care: Machine washing max 30°C / 85°F",
      "Care: Do not bleach",
      "Care: Ironing max 110°C / 230°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1025,
    name: "A-line skirt with stitching detail",
    category: "Bottoms",
    price: "44.99",
    country: "Mangoes Kids",
    rating: 4.8,
    reviewCount: 256,
    images: ["/img/1025.avif", "/img/1025a.avif", "/img/1025b.avif", "/img/1025c.avif"],
    size: ["35", "36", "37", "38", "39", "40", "41"],
    description: [
      "Flattering A-line silhouette with decorative stitching details.",
      "Sits at the natural waist for a polished look.",
      "Versatile style suitable for work or casual occasions.",
      "Pairs beautifully with blouses or simple tops.",
    ],
    Features: [
      "Type: A-line skirt with stitching detail",
      "Composition: 82% cotton, 15% polyamide, 3% elastane",
      "Origin: Designed in Barcelona, Manufacture: Morocco",
      "Origin: Dye/printing: Turkiye",
      "Origin: Weave: Turkiye",
      "Care: Machine washing max 30°C / 85°F",
      "Care: Do not bleach",
      "Care: Ironing max 150°C / 300°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1026,
    name: "Combined striped printed scarf",
    category: "Accessories",
    price: "9.99",
    country: "Mangoes Kids",
    rating: 4.4,
    reviewCount: 98,
    images: ["/img/1026.avif", "/img/1026a.avif", "/img/1026b.avif", "/img/1026c.avif"],
    size: ["One Size"],
    description: [
      "Vibrant combined striped print with colorful geometric patterns.",
      "Lightweight and smooth fabric with a silky feel.",
      "Versatile accessory that can be styled in multiple ways.",
      "Perfect for adding a pop of color to any outfit.",
    ],
    Features: [
      "Type: combined striped printed scarf",
      "Composition: 100% polyester",
      "Origin: Designed in Barcelona, Manufacture: China",
      "Origin: Dye/printing: China",
      "Origin: Weave: China",
      "Care: Hand washing max 30°C / 85°F",
      "Care: Do not bleach",
      "Care: Ironing max 110°C / 230°F",
      "Care: Do not dry clean",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1027,
    name: "Ruched strapless dress",
    category: "Dresses",
    price: "64.99",
    country: "Mangoes Kids",
    rating: 4.6,
    reviewCount: 176,
    images: ["/img/1027.avif", "/img/1027a.avif", "/img/1027b.avif", "/img/1027c.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Elegant strapless design with ruched bodice detailing.",
      "Flattering midi length with a flowy skirt.",
      "Sweetheart neckline and fitted waist.",
      "Perfect for summer parties or special occasions.",
    ],
    Features: [
      "Type: ruched strapless dress",
      "Composition: 82% cotton, 15% polyamide, 3% elastane",
      "Lining: 100% viscose",
      "Origin: Designed in Barcelona, Manufacture: Morocco",
      "Origin: Dye/printing: Turkiye",
      "Origin: Weave: Turkiye",
      "Care: Machine washing max 30°C / 85°F short spin dry",
      "Care: Do not bleach",
      "Care: Ironing max 150°C / 300°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1028,
    name: "Straight knit mini shorts",
    category: "Bottoms",
    price: "39.99",
    country: "Mangoes Kids",
    rating: 4.7,
    reviewCount: 223,
    images: ["/img/1028.avif", "/img/1028a.avif", "/img/1028b.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Sleek straight silhouette in a knit fabric.",
      "High-waisted design with a comfortable fit.",
      "Mini length perfect for warm weather.",
      "Versatile piece that pairs well with various tops.",
    ],
    Features: [
      "Type: straight knit mini shorts",
      "Composition: 59% polyamide, 41% viscose",
      "Origin: Designed in Barcelona, Manufacture: Turkiye",
      "Care: Hand washing max 30°C / 85°F",
      "Care: Do not bleach",
      "Care: Ironing max 110°C / 230°F",
      "Care: Do not dry clean",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1029,
    name: "Frilled denim mini shorts",
    category: "Bottoms",
    price: "35.99",
    country: "Mangoes Kids",
    rating: 4.5,
    reviewCount: 198,
    images: ["/img/1029.avif", "/img/1029a.avif", "/img/1029b.avif", "/img/1029c.avif", "/img/1029d.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Classic denim with playful frilled side details.",
      "High-rise waist with button and zip fly.",
      "Mini length with a flattering fit.",
      "Perfect for adding a feminine touch to casual outfits.",
    ],
    Features: [
      "Type: frilled denim mini shorts",
      "Composition: 100% cotton",
      "Origin: Designed in Barcelona, Manufacture: Turkiye",
      "Care: Machine washing max 40°C / 105°F",
      "Care: Do not bleach",
      "Care: Ironing max 150°C / 300°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Tumble dry",
    ],
  },
  {
    id: 1030,
    name: "Oversized cotton jacket",
    category: "Coats",
    price: "59.99",
    country: "Mangoes Kids",
    rating: 4.6,
    reviewCount: 287,
    images: ["/img/1030.avif", "/img/1030a.avif", "/img/1030b.avif", "/img/1030c.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Oversized fit for a relaxed, comfortable silhouette.",
      "Point collar and front zip closure.",
      "Long sleeves with button cuffs.",
      "Perfect for layering over any outfit.",
    ],
    Features: [
      "Type: oversized cotton jacket",
      "Composition: 97% cotton, 3% elastane",
      "Lining: 56% polyester, 44% viscose",
      "Origin: Designed in Barcelona, Manufacture: Cambodia",
      "Origin: Dye/printing: China",
      "Origin: Weave: China",
      "Care: Machine washing max 30°C / 85°F short spin dry",
      "Care: Do not bleach",
      "Care: Ironing max 110°C / 230°F",
      "Care: Do not dry clean",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1031,
    name: "Open back crop top",
    category: "Tops",
    price: "42.99",
    country: "Mangoes Kids",
    rating: 4.7,
    reviewCount: 234,
    images: ["/img/1031.avif", "/img/1031a.avif", "/img/1031b.avif", "/img/1031c.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Elegant ruffled trim along the neckline.",
      "Thin spaghetti straps and cropped length.",
      "Open back design for a chic look.",
      "Perfect for summer or special occasions.",
    ],
    Features: [
      "Type: open back crop top",
      "Composition: 82% cotton, 15% polyamide, 3% elastane",
      "Origin: Designed in Barcelona, Manufacture: Morocco",
      "Origin: Dye/printing: Turkiye",
      "Origin: Weave: Turkiye",
      "Care: Machine washing max 30°C / 85°F",
      "Care: Do not bleach",
      "Care: Ironing max 150°C / 300°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1032,
    name: "Suede obi belt",
    category: "Accessories",
    price: "24.99",
    country: "Mangoes Kids",
    rating: 4.6,
    reviewCount: 312,
    images: ["/img/1032.avif", "/img/1032a.avif", "/img/1032b.avif"],
    size: ["One Size"],
    description: [
      "Soft suede texture with a luxurious feel.",
      "Classic obi design with a tie closure.",
      "Versatile accessory that elevates any outfit.",
      "Perfect for cinching the waist of dresses or tops.",
    ],
    Features: [
      "Type: suede obi belt",
      "Composition: 100% bovine leather",
      "Origin: Designed in Barcelona, Manufacture: China",
      "Origin: Dye/printing: China",
      "Origin: Weave: China",
      "Care: No washing",
      "Care: Do not bleach",
      "Care: Do not iron",
      "Care: Do not dry clean",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1033,
    name: "Floral print skirt",
    category: "Bottoms",
    price: "39.99",
    country: "Mangoes Kids",
    rating: 4.8,
    reviewCount: 187,
    images: ["/img/1033.avif", "/img/1033a.avif", "/img/1033b.avif", "/img/1033c.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Beautiful floral print on a smooth satin-like fabric.",
      "Flattering midi length with a slight flare.",
      "Sits at the natural waist for a polished look.",
      "Perfect for adding a feminine touch to any outfit.",
    ],
    Features: [
      "Type: floral print skirt",
      "Composition: 100% viscose",
      "Lining: 100% polyester",
      "Origin: Designed in Barcelona, Manufacture: Morocco",
      "Origin: Dye/printing: Italy",
      "Origin: Weave: China",
      "Care: Machine washing max 30°C / 85°F",
      "Care: Do not bleach",
      "Care: Ironing max 150°C / 300°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1034,
    name: "Fitted cotton shirt",
    category: "Tops",
    price: "29.99",
    country: "Mangoes Kids",
    rating: 4.5,
    reviewCount: 298,
    images: ["/img/1034.avif", "/img/1034a.avif", "/img/1034b.avif", "/img/1034c.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Fitted silhouette that hugs the body perfectly.",
      "Classic point collar and short sleeves.",
      "Button-front closure with a cropped length.",
      "Versatile piece for work or casual wear.",
    ],
    Features: [
      "Type: fitted cotton shirt",
      "Composition: 82% cotton, 15% polyamide, 3% elastane",
      "Origin: Designed in Barcelona, Manufacture: Morocco",
      "Origin: Dye/printing: Turkiye",
      "Origin: Weave: Turkiye",
      "Care: Machine washing max 30°C / 85°F",
      "Care: Do not bleach",
      "Care: Ironing max 150°C / 300°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1035,
    name: "Fitted open-back dress",
    category: "Dresses",
    price: "44.99",
    country: "Mangoes Kids",
    rating: 4.6,
    reviewCount: 245,
    images: ["/img/1035.avif", "/img/1035a.avif", "/img/1035b.avif", "/img/1035c.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Sleek fitted silhouette with a mini length.",
      "High round neckline and sleeveless design.",
      "Open back for a chic, modern look.",
      "Perfect for parties or evening occasions.",
    ],
    Features: [
      "Type: fitted open-back dress",
      "Composition: 77% polyester, 20% polyamide, 3% elastane",
      "Piping: 100% viscose",
      "Origin: Designed in Barcelona, Manufacture: Morocco",
      "Origin: Dye/printing: Turkiye",
      "Origin: Weave: Turkiye",
      "Care: Machine washing max 30°C / 85°F short spin dry",
      "Care: Do not bleach",
      "Care: Ironing max 110°C / 230°F",
      "Care: Do not dry clean",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1036,
    name: "Flared trousers with welt pockets",
    category: "Bottoms",
    price: "40.99",
    country: "Mangoes Kids",
    rating: 4.7,
    reviewCount: 223,
    images: ["/img/1036.avif", "/img/1036a.avif", "/img/1036b.avif", "/img/1036c.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Elegant flared silhouette with a modern touch.",
      "High-rise waist with welt pockets.",
      "Smooth fabric with a polished finish.",
      "Perfect for both work and evening occasions.",
    ],
    Features: [
      "Type: flared trousers with welt pockets",
      "Composition: 95% cotton, 5% elastane",
      "Piping: 100% cotton",
      "Origin: Designed in Barcelona, Manufacture: Turkiye",
      "Care: Machine washing max 30°C / 85°F short spin dry",
      "Care: Do not bleach",
      "Care: Ironing max 110°C / 230°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1037,
    name: "Leather obi belt",
    category: "Accessories",
    price: "19.99",
    country: "Mangoes Kids",
    rating: 4.8,
    reviewCount: 412,
    images: ["/img/1037.avif", "/img/1037a.avif", "/img/1037b.avif", "/img/1037c.avif"],
    size: ["One Size"],
    description: [
      "Premium sheep leather with a smooth finish.",
      "Classic obi design with a tie closure.",
      "Wide silhouette that cinches the waist beautifully.",
      "Perfect for elevating dresses, coats, or tops.",
    ],
    Features: [
      "Type: leather obi belt",
      "Composition: 100% sheep leather",
      "Origin: Designed in Barcelona, Manufacture: China",
      "Origin: Dye/printing: China",
      "Origin: Weave: China",
      "Care: No washing",
      "Care: Do not bleach",
      "Care: Do not iron",
      "Care: Do not dry clean",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1038,
    name: "Chain-print scarf",
    category: "Accessories",
    price: "12.99",
    country: "Mangoes Kids",
    rating: 4.5,
    reviewCount: 176,
    images: ["/img/1038.avif", "/img/1038a.avif", "/img/1038b.avif"],
    size: ["One Size"],
    description: [
      "Bold chain print with vibrant colors.",
      "Smooth, silky texture with a luxurious feel.",
      "Versatile accessory that can be styled in multiple ways.",
      "Perfect for adding a statement to any outfit.",
    ],
    Features: [
      "Type: chain-print scarf",
      "Composition: 100% polyester",
      "Origin: Designed in Barcelona, Manufacture: China",
      "Origin: Dye/printing: China",
      "Origin: Weave: China",
      "Care: Hand washing max 30°C / 85°F",
      "Care: Do not bleach",
      "Care: Ironing max 110°C / 230°F",
      "Care: Do not dry clean",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1039,
    name: "Short dress with side slits",
    category: "Dresses",
    price: "45.99",
    country: "Mangoes Kids",
    rating: 4.6,
    reviewCount: 198,
    images: ["/img/1039.avif", "/img/1039a.avif", "/img/1039b.avif", "/img/1039c.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Elegant mini dress with a square neckline.",
      "Thin spaghetti straps and open back.",
      "Side slit details for added movement.",
      "Perfect for summer parties or special occasions.",
    ],
    Features: [
      "Type: short dress with side slits",
      "Composition: 100% polyester",
      "Lining: 100% viscose",
      "Origin: Designed in Barcelona, Manufacture: Morocco",
      "Origin: Dye/printing: Turkiye",
      "Origin: Weave: Turkiye",
      "Care: Hand washing max 30°C / 85°F",
      "Care: Do not bleach",
      "Care: Ironing max 110°C / 230°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1040,
    name: "Low-rise skinny jeans",
    category: "Bottoms",
    price: "45.99",
    country: "Mangoes Kids",
    rating: 4.7,
    reviewCount: 212,
    images: ["/img/1040.avif", "/img/1040a.avif", "/img/1040b.avif", "/img/1040c.avif", "/img/1040d.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Classic denim with a flattering low-rise fit.",
      "Slim, skinny silhouette that hugs the legs.",
      "Perfect for everyday casual wear.",
      "Pairs beautifully with various tops.",
    ],
    Features: [
      "Type: low-rise skinny jeans",
      "Composition: 80% cotton, 15% lyocell, 3% elastomultiester, 2% elastane",
      "Origin: Designed in Barcelona, Manufacture: Turkiye",
      "Care: Machine washing max 40°C / 105°F",
      "Care: Do not bleach",
      "Care: Ironing max 150°C / 300°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1041,
    name: "A-line dress with an open back",
    category: "Dresses",
    price: "69.99",
    country: "Mangoes Kids",
    rating: 4.8,
    reviewCount: 345,
    images: ["/img/1041.avif", "/img/1041a.avif", "/img/1041b.avif", "/img/1041c.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Elegant A-line silhouette with a midi length.",
      "Square neckline and wide shoulder straps.",
      "Open back with tie detail for a chic look.",
      "Perfect for summer or special occasions.",
    ],
    Features: [
      "Type: A-line dress with an open back",
      "Composition: 82% cotton, 15% polyamide, 3% elastane",
      "Lining: 100% cotton",
      "Origin: Designed in Barcelona, Manufacture: Morocco",
      "Origin: Dye/printing: Turkiye",
      "Origin: Weave: Turkiye",
      "Care: Machine washing max 30°C / 85°F",
      "Care: Do not bleach",
      "Care: Ironing max 150°C / 300°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1042,
    name: "High-waisted Mom-fit jeans",
    category: "Bottoms",
    price: "39.99",
    country: "Mangoes Kids",
    rating: 4.9,
    reviewCount: 523,
    images: ["/img/1042.avif", "/img/1042a.avif", "/img/1042b.avif", "/img/1042c.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Classic denim in a vibrant blue wash.",
      "High-rise waist with button and zip fly.",
      "Relaxed Mom fit with tapered leg.",
      "Five-pocket styling for everyday wear.",
    ],
    Features: [
      "Type: high-waisted Mom-fit jeans",
      "Composition: 100% cotton",
      "Origin: Designed in Barcelona, Manufacture: Tunisia",
      "Care: Machine washing max 30°C / 85°F short spin dry",
      "Care: Do not bleach",
      "Care: Ironing max 110°C / 230°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Tumble dry",
    ],
  },
  {
    id: 1043,
    name: "Flared midi-dress",
    category: "Dresses",
    price: "55.99",
    country: "Mangoes Kids",
    rating: 4.7,
    reviewCount: 267,
    images: ["/img/1043.avif", "/img/1043a.avif", "/img/1043b.avif", "/img/1043c.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Vibrant red color with a flattering fit.",
      "Thin spaghetti straps and square neckline.",
      "Flared midi skirt with a ruffled bodice detail.",
      "Perfect for parties or evening occasions.",
    ],
    Features: [
      "Type: flared midi-dress",
      "Composition: 100% cotton",
      "Lining: 100% polyester",
      "Origin: Designed in Barcelona, Manufacture: Turkiye",
      "Care: Machine washing max 30°C / 85°F short spin dry",
      "Care: Do not bleach",
      "Care: Ironing max 150°C / 300°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1044,
    name: "Braided leather belt",
    category: "Accessories",
    price: "6.99",
    country: "Mangoes Kids",
    rating: 4.6,
    reviewCount: 312,
    images: ["/img/1044.avif", "/img/1044a.avif", "/img/1044b.avif", "/img/1044c.avif", "/img/1044d.avif"],
    size: ["S", "M", "L", "XL"],
    description: [
      "Classic braided design with a timeless look.",
      "Genuine leather with a rich texture.",
      "Metal buckle for secure fastening.",
      "Perfect for adding a finishing touch to any outfit.",
    ],
    Features: [
      "Type: braided leather belt",
      "Composition: 100% bovine leather",
      "Buckle: 100% zinc",
      "Origin: Designed in Barcelona, Manufacture: China",
      "Origin: Dye/printing: China",
      "Origin: Weave: China",
      "Care: No washing",
      "Care: Do not bleach",
      "Care: Do not iron",
      "Care: Do not dry clean",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1045,
    name: "100% cotton sleeveless shirt",
    category: "Tops",
    price: "55.99",
    country: "Mangoes Kids",
    rating: 4.8,
    reviewCount: 198,
    images: ["/img/1045.avif", "/img/1045a.avif", "/img/1045b.avif", "/img/1045c.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Classic point collar with oversized shoulder pads.",
      "Sleeveless design with a button-front closure.",
      "Relaxed, slightly oversized fit.",
      "Versatile piece that can be dressed up or down.",
    ],
    Features: [
      "Type: 100% cotton sleeveless shirt",
      "Composition: 100% cotton",
      "Origin: Designed in Barcelona, Manufacture: Morocco",
      "Origin: Dye/printing: Spain",
      "Origin: Weave: Spain",
      "Care: Machine washing max 40°C / 105°F",
      "Care: Do not bleach",
      "Care: Ironing max 150°C / 300°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1046,
    name: "Check crop shirt",
    category: "Tops",
    price: "35.99",
    country: "Mangoes Kids",
    rating: 4.7,
    reviewCount: 287,
    images: ["/img/1046.avif", "/img/1046a.avif", "/img/1046b.avif", "/img/1046c.avif", "/img/1046d.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Classic check pattern with a cropped length.",
      "Point collar and short sleeves.",
      "Button-front closure.",
      "Fitted silhouette that hugs the body.",
    ],
    Features: [
      "Type: check crop shirt",
      "Composition: 100% cotton",
      "Origin: Designed in Barcelona, Manufacture: Morocco",
      "Origin: Dye/printing: Spain",
      "Origin: Weave: Spain",
      "Care: No washing",
      "Care: Do not bleach",
      "Care: Do not iron",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1047,
    name: "Short checked dress with ruffle detail",
    category: "Dresses",
    price: "49.99",
    country: "Mangoes Kids",
    rating: 4.9,
    reviewCount: 445,
    images: ["/img/1047.avif", "/img/1047a.avif", "/img/1047b.avif", "/img/1047c.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Charming check pattern with ruffle detail.",
      "Thin spaghetti straps and square neckline.",
      "Mini length with a straight fit.",
      "Perfect for casual summer outings.",
    ],
    Features: [
      "Type: short checked dress with ruffle detail",
      "Composition: 100% cotton",
      "Lining: 100% viscose",
      "Origin: Designed in Barcelona, Manufacture: Morocco",
      "Origin: Dye/printing: Spain",
      "Origin: Weave: Spain",
      "Care: No washing",
      "Care: Do not bleach",
      "Care: Do not iron",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1048,
    name: "Straight mid-rise trousers",
    category: "Bottoms",
    price: "49.99",
    country: "Mangoes Kids",
    rating: 4.6,
    reviewCount: 234,
    images: ["/img/1048.avif", "/img/1048a.avif", "/img/1048b.avif", "/img/1048c.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Halter neck design with a cropped top.",
      "Straight mid-rise trousers with wide leg.",
      "Coordinating two-piece set.",
      "Perfect for a chic, modern look.",
    ],
    Features: [
      "Type: straight mid-rise trousers",
      "Composition: 82% cotton, 15% polyamide, 3% elastane",
      "Lining: 100% viscose",
      "Origin: Designed in Barcelona, Manufacture: Morocco",
      "Origin: Dye/printing: Turkiye",
      "Origin: Weave: Turkiye",
      "Care: Machine washing max 30°C / 85°F",
      "Care: Do not bleach",
      "Care: Ironing max 150°C / 300°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1049,
    name: "Denim skirt with belt",
    category: "Bottoms",
    price: "35.99",
    country: "Mangoes Kids",
    rating: 4.8,
    reviewCount: 156,
    images: ["/img/1049.avif", "/img/1049a.avif", "/img/1049b.avif", "/img/1049c.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Classic denim in a vibrant blue wash.",
      "Mini length with a straight fit.",
      "Comes with a matching tie belt.",
      "Perfect for casual everyday wear.",
    ],
    Features: [
      "Type: denim skirt with belt",
      "Composition: 100% cotton",
      "Origin: Designed in Barcelona, Manufacture: Turkiye",
      "Care: Machine washing max 30°C / 85°F",
      "Care: Do not bleach",
      "Care: Ironing max 110°C / 230°F",
      "Care: Do not dry clean",
      "Care: Do not tumble dry",
    ],
  },
  {
    id: 1050,
    name: "Fine-knit crop top",
    category: "Tops",
    price: "10.99",
    country: "Mangoes Kids",
    rating: 4.7,
    reviewCount: 278,
    images: ["/img/1050.avif", "/img/1050a.avif", "/img/1050b.avif", "/img/1050c.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Fine-knit fabric with a ribbed texture.",
      "Square neckline and wide shoulder straps.",
      "Cropped length ending at the waist.",
      "Perfect for layering or wearing alone.",
    ],
    Features: [
      "Type: fine-knit crop top",
      "Composition: 59% polyamide, 41% viscose",
      "Origin: Designed in Barcelona, Manufacture: Turkiye",
      "Care: Hand washing max 30°C / 85°F",
      "Care: Do not bleach",
      "Care: Ironing max 110°C / 230°F",
      "Care: Do not dry clean",
      "Care: Do not tumble dry",
    ],
  },
  
];

export default productData;
